import { NgModule } from '@angular/core';
import { AirportNamePipe } from './airport-name.pipe';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [AirportNamePipe],
  providers: [StaticMsgModule],
  imports: [StaticMsgModule],
  exports: [AirportNamePipe],
})
export class AirportNamePipeModule {}
